import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

interface RelatedLinkItem {
  to: string;
  title: string;
  body: string;
}

interface RelatedLinksSectionProps {
  eyebrow?: string;
  title: string;
  description?: string;
  links: RelatedLinkItem[];
}

export const RelatedLinksSection = ({
  eyebrow = "— Relaterat",
  title,
  description,
  links,
}: RelatedLinksSectionProps) => {
  return (
    <section className="py-20 md:py-24 border-t border-border bg-background">
      <div className="container-page">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-5">
            <div className="eyebrow">{eyebrow}</div>
            <h2 className="display-md mt-6 text-foreground text-balance">{title}</h2>
          </div>
          {description ? (
            <div className="lg:col-span-6 lg:col-start-7">
              <p className="lead">{description}</p>
            </div>
          ) : null}
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {links.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="group rounded-sm border border-border bg-card p-6 transition-all hover:border-foreground/30 hover:shadow-soft"
            >
              <div className="flex items-start justify-between gap-4">
                <h3 className="font-display text-xl text-foreground">{item.title}</h3>
                <ArrowUpRight className="h-4 w-4 text-primary transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </div>
              <p className="mt-4 text-sm leading-relaxed text-foreground-muted">{item.body}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
